<template>
  <div class="exam-material">
    <div
      class="exam-material__title"
      @click="isActive = !isActive"
    >
      <div class="exam-material__title-static">Material</div>
      <div class="exam-material__title-dinamic">
        {{ currentItem.name }}
      </div>
      <button
        class="exam-material__btn"
        :class="{ 'exam-material__btn--active': isActive }"
      >
        <img
          src="/static/images/site/dropdown-arrow.svg"
          alt="seta"
        />
      </button>
    </div>
    <div
      v-if="isActive"
      class="exam-material__options"
    >
      <div
        v-for="(material, index) in materials"
        :key="`material-${index}-${material.id || material.name || index}`"
        class="exam-material__option"
        @click="handleOption(index)"
      >
        {{ material.name }}
      </div>
    </div>
    <div class="exam-material__content">
      <div class="exam-material__half">
        <p>Volume</p>
        <div class="exam-material__info">
          {{ currentItem.idealVolume }}
        </div>

        <p style="margin-top: 12px">Temperatura</p>
        <div class="exam-material__info">
          {{ currentItem.temperature }}
        </div>
      </div>
      <div class="exam-material__half">
        <p>Estabilidade da amostra</p>
        <div class="exam-material__stability">
          <div
            v-for="(item, index) in currentItem.sampleStabilities"
            :key="`stability-${index}-${item.id || item.environment || index}`"
            class="exam-material__stability-item"
          >
            <div class="exam-material__sample">
              <div>
                {{ item.environment }}
              </div>
            </div>
            <div class="exam-material__time">
              {{ item.quantity + ' ' + item.unitMeasure }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamMaterial',
  props: {
    materials: {
      type: Array,
      default: () => [],
    },
    method: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    isActive: false,
    index: 0,
  }),
  computed: {
    currentItem() {
      const index = this.index
      if (this.materials[index]) {
        return this.materials[index]
      }
      return {}
    },
  },
  mounted() {
    this.materials.findIndex(item => item.materialDefault)
  },
  methods: {
    handleOption(index) {
      this.index = index
      this.isActive = false
    },
  },
}
</script>

<style lang="scss">
.exam-material {
  position: relative;

  &__options {
    position: absolute;
    background-color: #fff;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.14);
    padding: 10px 0;
    width: 100%;
    border-radius: 0px 0px 6px 6px;
    z-index: 9;
    max-height: 300px;
    overflow-x: auto;
  }
  &__option {
    padding: 5px 16px;
    font-size: 14px;
    line-height: 26px;
    color: #4a4a4a;
    cursor: pointer;

    &:hover {
      background: #f5f5f5;
    }
  }
  &__btn {
    background-color: transparent;
    height: auto;
    padding: 4px;
    position: absolute;
    right: 20px;
    top: calc(50% - 12px);

    img {
      transform: rotate(0);
    }

    &--active {
      img {
        transform: rotate(180deg);
      }
    }
  }
  &__title {
    cursor: pointer;
    position: relative;
    background: linear-gradient(91.99deg, #7f1a54 26.25%, #da1e5d 130.32%);
    color: #fff;
    padding: 7px 15px 12px;
    border-radius: 4px;

    &-dinamic {
      font-weight: bold;
      font-size: 20px;
      text-transform: uppercase;
    }
  }
  &__full {
    display: flex;
    padding: 12px 16px 12px 12px;
    background-color: #fff;
    border-left: 4px solid #7f1a54;
    border-radius: 4px;
    width: 100%;
  }
  &__info {
    color: #303030;
    font-size: 16px;
  }
  &__half {
    width: calc(50% - 8px);
    background-color: #fff;
    margin-bottom: 8px;
    padding: 12px 16px 12px 12px;
    border-left: 4px solid #7f1a54;
    border-radius: 4px;
  }
  &__content {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    p {
      font-weight: 500;
      font-size: 14px;
      color: #7a7a7a;
      margin: 0 0 5px;
    }
  }
  &__stability {
    &-item {
      display: flex;
      flex-wrap: wrap;
      position: relative;
      top: -3px;
    }
  }

  &__stability > div {
    color: #303030;
    font-size: 16px;
  }

  &__time {
    width: 85px;
    white-space: nowrap;
    padding-left: 5px;
    position: relative;
    top: 3px;
  }

  &__sample {
    width: calc(100% - 85px);
    border-bottom: 1px dashed #b8b7bf;

    & > div {
      background-color: #fff;
      position: relative;
      top: 3px;
      display: inline-block;
      padding-right: 5px;
    }
  }
}
</style>
